import { render, staticRenderFns } from "./route-editor-help.vue?vue&type=template&id=4f04a10a"
import script from "./route-editor-help.vue?vue&type=script&lang=js"
export * from "./route-editor-help.vue?vue&type=script&lang=js"
import style0 from "./route-editor-help.vue?vue&type=style&index=0&id=4f04a10a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports